'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Status = require('./Status');

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Provides a callback mechanism for an item from a list of items.  Normally,
 * it is not a good idea to bind callback methods to items, and the linter will
 * complain.  This class provides a convenient callback mechanism bound to an
 * icon.
 *
 * @example
 *
 *  <div>
 *	  <ItemAction item={item} onAction={this.onEdit} className="edit" icon="pencil" />
 *	  <ItemAction item={item} onAction={this.onDelete} className="trash" icon="trash2" />
 *  </div>
 */
var ItemAction = function (_React$Component) {
	_inherits(ItemAction, _React$Component);

	function ItemAction(props) {
		_classCallCheck(this, ItemAction);

		var _this = _possibleConstructorReturn(this, (ItemAction.__proto__ || Object.getPrototypeOf(ItemAction)).call(this, props));

		_this.onClick = _this.onClick.bind(_this);
		return _this;
	}

	_createClass(ItemAction, [{
		key: 'onClick',
		value: function onClick(e) {
			var _props = this.props,
			    onAction = _props.onAction,
			    item = _props.item;

			if (e) {
				e.stopPropagation();
			}
			if (onAction) {
				onAction(item);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    className = _props2.className,
			    icon = _props2.icon,
			    tooltip = _props2.tooltip,
			    tooltipPlacement = _props2.tooltipPlacement,
			    disabled = _props2.disabled;

			return _react2.default.createElement(_Status2.default, {
				label: '',
				disabled: disabled,
				className: className,
				icon: ' gg icon-GG-' + icon,
				onClick: this.onClick,
				tooltip: tooltip,
				tooltipPlacement: tooltipPlacement
			});
		}
	}]);

	return ItemAction;
}(_react2.default.Component);

var _default = ItemAction;
exports.default = _default;


ItemAction.propTypes = {
	item: _propTypes2.default.object.isRequired,
	icon: _propTypes2.default.string,
	className: _propTypes2.default.string,
	bsStyle: _propTypes2.default.string,
	tooltip: _propTypes2.default.string,
	tooltipPlacement: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
	disabled: _propTypes2.default.bool,
	onAction: _propTypes2.default.func
};

ItemAction.defaultProps = {
	className: '',
	bsStyle: 'default',
	icon: 'axway',
	disabled: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ItemAction, 'ItemAction', 'src/components/ItemAction.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ItemAction.jsx');
}();

;